import { Route } from '@angular/router';
import { subscriptionAccessGuard } from '@rma/dashboard/billing/subscription-plans/public/api-subscription-features';

export const socialMediaRoutes: Route[] = [
  {
    path: '',
    loadChildren: () => import('@rma/dashboard/social-media-manager/manage-shell'),
  },
  {
    path: 'post',
    loadChildren: () => import('@rma/dashboard/social-media-manager/share'),
    canActivate: [subscriptionAccessGuard('HasSocialMedia', '/socialmedia/about')],
  },
  // Legacy SMM manual post redirects.
  {
    path: 'share',
    loadChildren: () => import('@rma/dashboard/social-media-manager/share').then((m) => m.legacySocialMediaShareRoutes),
  },
];
